import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { applicationHistory } from '../../common/application-history';
import UrlMappings from '../../common/url-mappings';
import AlbumAddNew from '../../album-view/components/dialog/album-add-new';
import { Dialog } from '../../common/components/dialog';
import { toggleHeaderMenuExpanded } from '../../settings/actions/application-actions';
import {PopupMenu} from "../../common/components/popup-menu";
import {getAlbumInArrayById,setAlbumSort} from "../../album-view/actions/album-actions";

class AlbumViewHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isAddNewDialogOpen:false,
            menuItems: [],
            menuPosition: {x: 0, y: 0},
            menuVisible: false,
            menuItemId: 0,
		};

		this.openAddAlbumDialog = this.openAddAlbumDialog.bind(this);
		this.setSortOrder = this.setSortOrder.bind(this);
		this.createMenuItems = this.createMenuItems.bind(this);
		this.showMenu = this.showMenu.bind(this);
		this.hideMenu = this.hideMenu.bind(this);
		this.getOrderByFriendlyName = this.getOrderByFriendlyName.bind(this);
		this.onAddAlbumCancel = this.onAddAlbumCancel.bind(this);
	}

	componentDidMount() {
        this._ismounted = true;
		this.createMenuItems();
	}
    componentWillUnmount() {
        this._ismounted = false;
    }
	setSortOrder(sortOrder){
        this.setState({menuVisible:false})
		this.props.setAlbumSort(sortOrder);
	}

    createMenuItems() {
        let menuItemArray = [
            {
                id: 'Sort A-Z',
                action: () => this.setSortOrder("alpha(asc)")
            },
            {
                id: 'Sort Z-A',
                action: () => this.setSortOrder("alpha(desc)")
            },
            {
                id: 'Sort By Newest',
                action: () => this.setSortOrder("date(desc)")
            },
            {
                id: 'Sort By Oldest',
                action: () => this.setSortOrder("date(asc)")
            },
            {
                id: 'Sort Custom',
                action: () => this.setSortOrder("custom")
            }
			]
        return menuItemArray;
	}
	getOrderByFriendlyName(orderBy){
		if(orderBy == "alpha(asc)") return "Sort A-Z";
        if(orderBy == "alpha(desc)") return "Sort Z-A";
        if(orderBy == "date(desc)") return "Sort By Newest";
        if(orderBy == "date(asc)") return "Sort By Oldest";
        if(orderBy == "custom") return "Sort Custom";
	}
    hideMenu(){
        if(this._ismounted) {
            this.setState({menuVisible: false});
        }
    }
    showMenu(evt) {
        const menuPosition = {
            x: evt.pageX - 100,
            y: evt.pageY + 10
        };

        this.setState({menuPosition: menuPosition});
        this.setState({menuItems: this.createMenuItems()});

        if (!this.state.menuVisible) {
            this.setState({
                menuVisible: true
            });
        }
        evt.stopPropagation();

    }
	openAddAlbumDialog() {
		this.setState({isAddNewDialogOpen:true})
	}

	enableAlbumSelectionMode() {
		applicationHistory.push(UrlMappings.ALBUMS_SELECT);
	}
    openDiscWizard() {
        applicationHistory.push("/my/disc-wizard");
    }

	navigateHome() {
		applicationHistory.push(UrlMappings.HOME);
	}
	openOrderStatus(){
		applicationHistory.push("/my/order-status");
	}

	favoriteAlbums() {
		const { favoriteAlbums, selectedItems } = this.props;
		favoriteAlbums([...selectedItems]);
	}
	onAddAlbumCancel(){

		this.setState({isAddNewDialogOpen:false})
	}

	render() {
		const { toggleHeaderMenuExpanded,albumList } = this.props;
		return (
			<header className="header-flex-container header-default">
				<div className="header-flex-left">
					<div className="hamburger-menu-container" onClick={toggleHeaderMenuExpanded}>
						<div className="hamburger-menu" />
						Menu
					</div>
					<div className="header-item logo" onClick={this.props.navigateHome}>
						&nbsp;
						<span className="hidden">iMemories&reg;</span>
					</div>
				</div>

				<div className="header-flex-right">
					<div className="header-flex-spacer" />

					{this.props.hasOpenOrder && <div className="header-item header-item-right" onClick={this.openOrderStatus}>
						<div className="header-label">Order Status</div>
					</div>}
					<div className="header-item header-item-right" onClick={this.openAddAlbumDialog}>
						<div className="header-icon add-to-album" />
						<div className="header-label">Add New Album</div>
					</div>

					<div className="header-flex-spacer" />
					{albumList.count > 0 && this.props.albumList.orderBy == "custom" &&

					<div
						className="header-item header-item-right"
						onClick={() => {
							applicationHistory.push(`${applicationHistory.location.pathname}/arrange`);
						}}>
						<div className="header-icon arrange" />
						<div className="header-label">Arrange</div>
					</div>
					}

					<div
						className="header-item header-item-right"
						onClick={() => {
							this.enableAlbumSelectionMode(this.enableAlbumSelectionMode);
						}}>
						<div className="header-icon select" />
						<div className="header-label">Select</div>
					</div>
					<div className="header-item header-item-right" onClick={this.showMenu}>
						<div className="header-label">{this.getOrderByFriendlyName(this.props.albumList.orderBy)}</div>
						<div className="header-icon header-caret caret" />
					</div>
				</div>
				{this.state.isAddNewDialogOpen &&
				<Dialog
					isOpen={this.state.isAddNewDialogOpen}
					onClose={()=>this.setState({isAddNewDialogOpen:false})}
					title="Add New Album">
					<AlbumAddNew {...this.props} onCancel={this.onAddAlbumCancel} />
				</Dialog>
                }
                <PopupMenu
                    menuItems={this.state.menuItems}
                    position={this.state.menuPosition}
                    visibility={this.state.menuVisible}
                    hideMenu={this.hideMenu}
                />
			</header>
		);
	}
}

AlbumViewHeader.propTypes = {
	toggleHeaderMenuExpanded: PropTypes.func,
	toggleAlbumArrange: PropTypes.func,
	favoriteAlbums: PropTypes.object,
	selectedItems: PropTypes.array,
	navigateHome: PropTypes.func,
	albumList: PropTypes.object
};
const mapStateToProps = state => {
    return {
        albumList: state.albumList,
		hasOpenOrder: state.orderStatus.orders.some(it=>it.orderStatus === "Open")
    }
}

const mapDispatchToProps = dispatch => {
	return {
		toggleHeaderMenuExpanded: evt => {
			dispatch(toggleHeaderMenuExpanded());
			if (evt) evt.stopPropagation();
		},
        setAlbumSort: (orderBy) => dispatch(setAlbumSort(orderBy)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumViewHeader);



// WEBPACK FOOTER //
// ./src/header/components/album-view-header.jsx